import { render, staticRenderFns } from "./JudgeStoriesList.vue?vue&type=template&id=0352ef40"
import script from "./JudgeStoriesList.vue?vue&type=script&lang=js"
export * from "./JudgeStoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports